/** @format */

import { Component, Input, OnInit } from '@angular/core';

import { TaggingService } from '@shared/data-access/services';

@Component({
	selector: 'shared-media-component-media',
	templateUrl: './media.component.html',
	providers: [TaggingService],
	standalone: false
})
export class MediaComponent implements OnInit {
	@Input() altText: string;
	// default Desktop image used with Scene 7
	@Input() image: string;
	// Optional Mobile image used with Scene 7
	@Input() mobileImg: string;
	// Optional Gif used with Scene 7
	@Input() gif: string;
	// Optional Mobile Gif used with Scene 7
	@Input() gifMobile: string;
	// Title used for the title attribute associated with the image
	@Input() itemTitle: string;
	// Optional animation used with Scene 7
	@Input() animation: string;
	// Optional youtubeId that is used with Media Video Component
	@Input() youtubeId: string;
	// Optional image param used at the end of a scene 7 image url for optimization
	@Input() imagePreset: any;
	// Optional image param used at the end of a akamai image url for optimization
	@Input() imageWidthParam: string;
	// Boolean to determine if you want the image to lazy load or not
	@Input() willLazyLoad = false;
	// Array of the data uploaded to the homR Image Uploader and used with media homr asset component
	@Input() visualAssets: any[];
	// Position on page
	@Input() imagePagePosition = 0;
	// Decide if the image will be set as high priority or not
	@Input() prioritize = false;

	public visualAssetEmpty = true;

	ngOnInit() {
		if (this.visualAssets) {
			this.visualAssetEmpty = !this.isVisualAssetsValid(this.visualAssets);
		}

		if (Number(this.imagePagePosition) <= 4 && this.willLazyLoad === true) {
			this.willLazyLoad = false;
		}
	}

	/**
	 * @description
	 *  Checks the value of the array passed for Visual Assets and returns true is the properties exist and
	 *  are valid for the media-homr-asset component to use.
	 *  Returns falsy if the visual assets array passed is empty or has invalid properties.
	 * @param - {visualAssets} array - each element could contain at least one object that has visual asset properties inside, and a length of the number of those properties
	 * Ex. [{0: {value: 'image', type: 'image', altText: 'some alt text'}, length: 1}]
	 */
	public isVisualAssetsValid(visualAssets: any[]): boolean {
		for (const va in visualAssets) {
			if (visualAssets[va]?.length) {
				const { length, ...assets } = visualAssets[va];
				if (length > 0) {
					return this.isVisualAssetObjectValid(assets);
				}
			}
		}

		return false;
	}

	private isVisualAssetObjectValid(assets: any[]) {
		let allKeysValid = true;
		for (const p in Object.keys(assets)) {
			if (Object.keys(assets[p]) && assets[Object.keys(assets)[p]]) {
				const property = Object.keys(assets)[p];
				const asset: any = assets[property];
				if (Object.keys(asset)?.length === 0) {
					allKeysValid = false;
				}
			}
		}
		return allKeysValid;
	}
}
